exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component=\"description-tax\"] {\n  position: relative;\n}\n[data-component=\"description-tax\"] .text,\n[data-component=\"description-tax\"] .images {\n  display: inline-block;\n  vertical-align: middle;\n}\n[data-component=\"description-tax\"] .images {\n  margin-right: 19px;\n}\n[data-component=\"description-tax\"] .images img {\n  margin-right: 10px;\n}\n[data-component=\"description-tax\"] .images img:last-child {\n  margin: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/description-tax/description-tax.component.styl
// module id = ../../../../../src/app/master/payment-federal-taxes/description-tax/description-tax.component.styl
// module chunks = main